import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../commons/Auth';
import { useAlert } from 'react-alert';
import {
  Col,
  CustomInput,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import { ContFilterYear } from '../../../styled-components';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import variables from '../../../variables';
import classNames from 'classnames';
import { Link, Route, Switch, Redirect } from 'react-router-dom';
import SignalsCondo from './SignalsCondo';
import SignalsSpecialJobs from './SignalsSpecialJobs';
import SignalsRentalsSales from './SignalsRentalsSales';

const VarRevSignalsDetailPresentational = ({
  data = {},
  total,
  profile,
  query,
  onFilter,
  onAddBonus,
  fetchReportsSignals,
  match,
  location,
  setQuery,
  profileId,
}) => {
  const [t] = useTranslation('SIGNALS');
  const [{ newIsAdmin }] = useAuth();
  const alert = useAlert();
  const { params: { id } = {}, url = '' } = match;
  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  const origin = window.location.origin;
  let hash = window.location.hash.split('/');
  hash.pop();
  hash.pop();
  const prevPath =
    origin +
    '/' +
    hash.join('/') +
    `${query.year ? '?year=' + query.year : ''}`;

  if (pathname === url) {
    return <Redirect to={`${url}/signals-condo-revenues`} />;
  }

  return (
    <>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <ContFilterYear>
            <Row>
              <Col xs="6">
                <Label>{t('TITLE_FILTER_YEAR')}</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="selectYear"
                    name="year"
                    value={query && query.year}
                    onChange={({ target: { value: year } }) =>
                      onFilter({ year })
                    }
                  >
                    {generateYearOptions()}
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>

          <div
            style={{
              fontWeight: 700,
              color: '#333333',
              marginBottom: '20px',
              fontSize: '20px',
            }}
          >
            <a
              style={{
                color: variables.primary,
              }}
              href={prevPath}
            >
              Rendicontazioni
            </a>{' '}
            / <a>{t('ROYALTIES_TITLE')}</a>
          </div>

          <section>
            <TabContent activeTab={'2'}>
              <TabPane tabId="2">
                <section>
                  <div className="m-tb-5">
                    <Nav style={{ backgroundColor: '#F3F3F3' }} tabs>
                      <NavItem>
                        <NavLink
                          tag={Link}
                          to={`${match.url}/signals-condo-revenues?signalTypeCode=CONDO`}
                          className={classNames({
                            active: tab === 'signals-condo-revenues',
                          })}
                        >
                          {t('PAGES:SIGNALS_CONDO_TAB')}
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          tag={Link}
                          to={`${match.url}/signals-special-jobs-revenues?signalTypeCode=SPECIAL_JOBS`}
                          className={classNames({
                            active: tab === 'signals-special-jobs-revenues',
                          })}
                        >
                          {t('PAGES:SIGNALS_SPECIAL_JOBS_TAB')}
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          tag={Link}
                          to={`${match.url}/signals-rentals-sales-revenues?signalTypeCode=RENTALS_SALES`}
                          className={classNames({
                            active: tab === 'signals-rentals-sales-revenues',
                          })}
                        >
                          {t('PAGES:SIGNALS_RENTALS_SALES_TAB')}
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <Switch>
                      <Route
                        path={`${match.url}/signals-condo-revenues`}
                        component={(props) => (
                          <SignalsCondo
                            data={data}
                            query={query}
                            total={total}
                            onFilter={onFilter}
                            profile={profile}
                            onAddBonus={onAddBonus}
                            fetchReportsSignals={fetchReportsSignals}
                            profileId={profileId}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        path={`${match.url}/signals-special-jobs-revenues`}
                        component={(props) => (
                          <SignalsSpecialJobs
                            data={data}
                            query={query}
                            total={total}
                            onFilter={onFilter}
                            profile={profile}
                            onAddBonus={onAddBonus}
                            fetchReportsSignals={fetchReportsSignals}
                            profileId={profileId}
                            {...props}
                          />
                        )}
                      />

                      <Route
                        path={`${match.url}/signals-rentals-sales-revenues`}
                        component={(props) => (
                          <SignalsRentalsSales
                            data={data}
                            query={query}
                            total={total}
                            onFilter={onFilter}
                            profile={profile}
                            onAddBonus={onAddBonus}
                            fetchReportsSignals={fetchReportsSignals}
                            profileId={profileId}
                            {...props}
                          />
                        )}
                      />
                    </Switch>
                  </div>
                </section>
              </TabPane>
            </TabContent>
          </section>
        </TabPane>
      </TabContent>
    </>
  );
};

export default VarRevSignalsDetailPresentational;
